import React from "react";
import { FormattedMessage } from "react-intl";
import {
  SelectAll,
  SelectNone,
  SelectorsContainer,
  StyledDropdown,
  StyledDropdownMenu,
  StyledDropDownToggle,
  StyledLabel,
} from "./styles";
import { messages } from "./messages";
import { AriFilterType } from "../index";

interface Props {
  name: AriFilterType;
  items: { value: string; label: string; }[];
  title: string;
  selected: string[];
  onChange: (
    filter: AriFilterType,
    value: string
  ) => void;
  onSelectAll: () => void;
  onSelectNone: () => void;
}

export const FilterDropdown = (
  {
    name,
    items,
    onChange,
    title,
    selected,
    onSelectAll,
    onSelectNone
  }: Props
) => (
  <StyledDropdown role="dropdown" disabled={!(!!selected.length)}>
    <StyledDropDownToggle id={`dropdown-${name}`}>
      {title}
      {!!selected.length && ` (${selected.length})`}
    </StyledDropDownToggle>

    <StyledDropdownMenu>
      {items.map(it => (
        <StyledLabel>
          <input
            type={"checkbox"}
            checked={selected.includes(it.value)}
            onChange={() => onChange(name, it.value)}
          />
          <span>{it.label}</span>
        </StyledLabel>
      ))}
      <SelectorsContainer>
        <SelectAll onClick={onSelectAll}>
          <FormattedMessage {...messages.selectAll} />
        </SelectAll>
        <SelectNone onClick={onSelectNone}>
          <FormattedMessage {...messages.selectNone} />
        </SelectNone>
      </SelectorsContainer>
    </StyledDropdownMenu>
  </StyledDropdown>
);
